import { render, staticRenderFns } from "./viewPTRound.vue?vue&type=template&id=2c4cb20c&scoped=true&"
import script from "./viewPTRound.vue?vue&type=script&lang=js&"
export * from "./viewPTRound.vue?vue&type=script&lang=js&"
import style0 from "./viewPTRound.vue?vue&type=style&index=0&id=2c4cb20c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4cb20c",
  null
  
)

export default component.exports